<div class="flex-1 flex flex-col overflow-auto">
  <!-- Users Content -->
  <main class="flex-1 overflow-y-auto p-6 ipad-scrollable">
    <!-- Desktop header (xl and above) - Original single line layout -->
    <div class="hidden xl:flex items-center justify-between mb-6">
      <!-- Left: Users Title Only -->
      <h1 class="text-2xl font-bold text-gray-900">Users</h1>

      <!-- Right: Filter Dropdowns, Search, Sort, and Add New Button Grouped Together -->
      <div class="flex items-center gap-4" [formGroup]="filterForm">
        <!-- Filter By: Type Dropdown -->
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-600">Filter By:</span>
          <p-select
            [options]="typeOptions"
            formControlName="selectedType"
            (onChange)="onTypeChange($event.value)"
            optionLabel="label"
            optionValue="value"
            placeholder="Type"
            styleClass="filter-dropdown"
            appendTo="body"
            [virtualScroll]="false"
            [filter]="false"
          ></p-select>
        </div>

        <!-- Filter By: Status Dropdown -->
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-600">Status:</span>
          <p-select
            [options]="statusOptions"
            formControlName="selectedStatus"
            (onChange)="onStatusChange($event.value)"
            optionLabel="label"
            optionValue="value"
            placeholder="Status"
            styleClass="filter-dropdown"
            appendTo="body"
            [virtualScroll]="false"
            [filter]="false"
          ></p-select>
        </div>

        <!-- Search Bar -->
        <app-search-bar
          [placeholder]="'Search'"
          [value]="filterForm.get('searchTerm')?.value"
          (searchChange)="onSearchChange($event)"
        ></app-search-bar>

        <!-- Sort Dropdown -->
        <app-sort-dropdown
          [options]="sortOptions"
          [control]="sortControl"
          [placeholder]="'Sort By:'"
          (sortChange)="onSortChange($event)"
        ></app-sort-dropdown>

        <!-- Add New Button -->
        <button
          pButton
          type="button"
          label="+Add New"
          class="add-new-btn"
          routerLink="/users/create"
        ></button>
      </div>
    </div>

    <!-- iPad header (md to xl) - Two line layout -->
    <div class="hidden md:block xl:hidden mb-6">
      <!-- First Line: Users Title, Filter By, and Add New Button -->
      <div class="flex justify-between items-center mb-4">
        <!-- Left: Users Title -->
        <h1 class="text-2xl font-semibold text-gray-800">Users</h1>

        <!-- Right: Filter By and Add New Button -->
        <div class="flex items-center gap-4" [formGroup]="filterForm">
          <!-- Filter By: Type Dropdown -->
          <div class="flex items-center gap-2">
            <span class="text-sm text-gray-600">Filter By:</span>
            <p-select
              [options]="typeOptions"
              formControlName="selectedType"
              (onChange)="onTypeChange($event.value)"
              optionLabel="label"
              optionValue="value"
              placeholder="Type"
              styleClass="filter-dropdown"
              appendTo="body"
              [virtualScroll]="false"
              [filter]="false"
            ></p-select>
          </div>

          <!-- Add New Button -->
          <button
            pButton
            type="button"
            label="+Add New"
            class="add-new-btn"
            routerLink="/users/create"
          ></button>
        </div>
      </div>

      <!-- Second Line: Status, Search, and Sort By -->
      <div
        class="flex items-center justify-between gap-4"
        [formGroup]="filterForm"
      >
        <!-- Filter By: Status Dropdown -->
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-600">Status:</span>
          <p-select
            [options]="statusOptions"
            formControlName="selectedStatus"
            (onChange)="onStatusChange($event.value)"
            optionLabel="label"
            optionValue="value"
            placeholder="Status"
            styleClass="filter-dropdown"
            appendTo="body"
            [virtualScroll]="false"
            [filter]="false"
          ></p-select>
        </div>

        <!-- Search Bar -->
        <div class="flex-1 max-w-md mx-4">
          <app-search-bar
            [placeholder]="'Search'"
            [value]="filterForm.get('searchTerm')?.value"
            (searchChange)="onSearchChange($event)"
          ></app-search-bar>
        </div>

        <!-- Sort Dropdown -->
        <app-sort-dropdown
          [options]="sortOptions"
          [control]="sortControl"
          [placeholder]="'Sort By:'"
          (sortChange)="onSortChange($event)"
        ></app-sort-dropdown>
      </div>
    </div>

    <!-- Mobile header: Line 1 (Title + Sort visible + filter icon buttons) -->
    <div class="md:hidden mb-3">
      <div class="flex items-center justify-between">
        <h1 class="text-xl font-bold text-gray-900">Users</h1>
        <div class="flex items-center gap-2 relative">
          <!-- Sort visible -->
          <app-sort-dropdown
            [options]="sortOptions"
            [control]="sortControl"
            [placeholder]="'Sort By:'"
            (sortChange)="onSortChange($event)"
          ></app-sort-dropdown>

          <!-- Type icon trigger -->
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-text"
            icon="pi pi-filter"
            (click)="toggleTypeMenu()"
            aria-label="Filter by type"
          ></button>
          <div
            *ngIf="showTypeMenu"
            class="absolute z-20 bg-white border border-gray-200 rounded-md shadow-md p-3 right-0 top-12 w-48"
            [formGroup]="filterForm"
          >
            <div class="text-xs text-gray-500 mb-2">Filter By</div>
            <p-select
              [options]="typeOptions"
              formControlName="selectedType"
              (onChange)="onTypeChange($event.value); closeMenus()"
              optionLabel="label"
              optionValue="value"
              placeholder="Type"
              styleClass="filter-dropdown w-full"
            ></p-select>
          </div>

          <!-- Status icon trigger -->
          <button
            pButton
            type="button"
            class="p-button-rounded p-button-text"
            icon="pi pi-check-circle"
            (click)="toggleStatusMenu()"
            aria-label="Filter by status"
          ></button>
          <div
            *ngIf="showStatusMenu"
            class="absolute z-20 bg-white border border-gray-200 rounded-md shadow-md p-3 right-0 top-12 w-48"
            [formGroup]="filterForm"
          >
            <div class="text-xs text-gray-500 mb-2">Status</div>
            <p-select
              [options]="statusOptions"
              formControlName="selectedStatus"
            (onChange)="onStatusChange($event.value)"
              optionLabel="label"
              optionValue="value"
              placeholder="Status"
              styleClass="filter-dropdown w-full"
              (onChange)="closeMenus()"
            ></p-select>
          </div>
        </div>
      </div>

      <!-- Mobile header: Line 2 (Search + Add) -->
      <div class="flex items-center justify-between gap-2 mt-3">
        <app-search-bar
          [placeholder]="'Q Search'"
          [value]="filterForm.get('searchTerm')?.value"
          (searchChange)="onSearchChange($event)"
        ></app-search-bar>
        <button
          pButton
          type="button"
          class="add-new-btn"
          routerLink="/users/create"
        >
          <span class="hidden sm:inline">+Add New</span>
          <span class="sm:hidden">+</span>
        </button>
      </div>
    </div>

    @if (loading) {
    <!-- Loading State -->
    <div class="flex items-center justify-center min-h-[400px]">
      <app-loader
        type="inline"
        message="Loading users..."
        size="large"
        ariaLabel="Loading users"
      >
      </app-loader>
    </div>
    } @else {
    <!-- Users Table -->
    <div
      class="hidden xl:block bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden"
    >
      <app-table
        [data]="users"
        [columns]="columns"
        [loading]="loading"
        [context]="'users'"
        [isArchivedView]="filterForm.get('selectedStatus')?.value === 'archive'"
        (statusToggle)="onToggleStatus($event.row, $event.event)"
        (edit)="onEditUser($event)"
        (delete)="onDeleteUser($event)"
      ></app-table>
      <app-pagination
        [paginationInfo]="paginationInfo"
        (pageChange)="onPageChange($event)"
      ></app-pagination>
    </div>

    <!-- Card List for iPad Pro and Mobile -->
    <div class="xl:hidden">
      <app-card-list
        [data]="users"
        [context]="'users'"
        [isArchivedView]="filterForm.get('selectedStatus')?.value === 'archive'"
        (edit)="onEditUser($event)"
        (delete)="onDeleteUser($event)"
      ></app-card-list>

      <!-- Pagination for iPad Pro and Mobile -->
      <app-pagination
        [paginationInfo]="paginationInfo"
        (pageChange)="onPageChange($event)"
      ></app-pagination>
    </div>
    }
  </main>
</div>

<!-- Archive Confirmation Modal -->
<app-modal
  [(visible)]="showDeleteModal"
  modalType="confirm"
  title="Archive User"
  message="Are you sure you want to archive this user? This action cannot be undone."
  [confirmButtonText]="isDeleting ? 'Archiving...' : 'Confirm'"
  [confirmButtonDisabled]="isDeleting"
  cancelButtonText="Back"
  width="400px"
  (confirm)="confirmDeleteUser()"
  (close)="cancelDeleteUser()"
></app-modal>

<!-- Toast Messages -->
<p-toast position="top-right"></p-toast>
